module.exports = __webpack_public_path__ + "static/media/logo_desarrollo1.bfdac8e3.png";